const {
	VUE_APP_APPOINT_FORMID,
	VUE_APP_VIEW_FORMID,
	VUE_APP_FORM_BASE,
	VUE_APP_VC_COURSE
} = window.env
import { getSubmitResult } from '@/service/index'
import { concatURI } from '@/utils/common'
import { FORM_ITEM_NAME } from '@/configs/constants'
import fetchData from '@/service/fetchData'

export default {
	data() {
		return {
			submitResult: {}
		}
	},
	methods: {
		async viewCourse({ id, name }) {
			const iw = isWebinar(id)
			const formId = iw ? VUE_APP_APPOINT_FORMID : VUE_APP_VIEW_FORMID
			if (!this.submitResult[formId]) {
				this.submitResult[formId] = await getSubmitResult(formId, [FORM_ITEM_NAME])
			}
			const hasSubmit = this.submitResult[formId].some((item) => {
				const { value } = item.options.find((op) => op.itemName === FORM_ITEM_NAME)
				return value === id
			})

			if (hasSubmit) {
				const routeName = iw ? 'VCWebinarEntry' : 'VCCourseDetail'
				this.$router.push({
					name: routeName,
					params: { id }
				})
			} else {
				if (!iw) {
					const list = await fetchData(VUE_APP_VC_COURSE)
					const t = list.find((item) => item.id === id)
					name = t ? t.name : name
				}
				window.location.href = getLink(formId, {
					id,
					name,
					fullPath: this.$route.fullPath
				})
			}
		}
	}
}
function isWebinar(id) {
	return id.startsWith('w')
}
export function getLink(formId, { id, name, fullPath }) {
	return concatURI(VUE_APP_FORM_BASE + formId, [
		{ key: 'c_' + FORM_ITEM_NAME, val: id },
		{ key: 'c_courseName', val: name },
		{ key: 'fullPath', val: fullPath }
	])
}
